import {LocalDate} from '@js-joda/core';
import type {Order, RawOrder} from '@/types/order';

export const mapRawToOrder = (raw : RawOrder) : Order => ({
    ...raw,
    deliveryDate: LocalDate.parse(raw.deliveryDate),
});
